import { INoRowsOverlayParams } from '@ag-grid-community/core';
import { INoRowsOverlayAngularComp } from '@ag-grid-community/angular';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { StorageService } from '@services';
import { from, Subject } from 'rxjs';
import { FIRM_TOKEN } from '@utils/app.constants';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ft-no-row-overlay-render-my-literature',
  templateUrl: './no-row-overlay-render.component.html',
})
export class NoRowOverlayRenderMyLiteratureComponent
  implements INoRowsOverlayAngularComp, OnInit, OnDestroy {
  private unsubscribe$: Subject<void> = new Subject<void>();

  public isPrimericaUser = false;

  constructor(private storageService: StorageService) {}

  agInit(params: INoRowsOverlayParams): void {}

  ngOnInit(): void {
    const firmToken$ = from(this.storageService.retrieve(FIRM_TOKEN));

    firmToken$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((firmToken: string) => {
        this.isPrimericaUser = firmToken === 'partner-primerica';
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
